export default () => ({
  componentName: 'cell-network-name',
});
